// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form } from 'informed';

import { login } from '../../actions/accountActions';

import { Button, PrimaryButton } from '../Buttons.jsx';
import { Error } from '../Typography.jsx';
import RequiredText from '../RequiredText.jsx';

import styles from '../../styles/accountPages/LoginPage.scss';

const publicUrl = process.env.publicUrl || '';

type Props = {
  login: Function,
  loginError: ?string,
  loginLoading: boolean,
}

class LoginPageComponent extends Component<Props> {
  formApi: {
    getState: Function,
    getValue: Function,
    setError: Function,
  }

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  submitLogin = () => {
    const state = this.formApi.getState();
    if (state.invalid) {
      return;
    }
    if (!this.formApi.getValue('username')) {
      this.formApi.setError('username', 'Error');
      return;
    }
    if (!this.formApi.getValue('password')) {
      this.formApi.setError('password', 'Error');
      return;
    }
    const { username, password } = state.values;
    this.props.login(username, password);
  }

  enter = ({ key }) => {
    if (key === 'Enter') {
      this.submitLogin();
    }
  }

  render() {
    if (this.props.loginLoading) {
      // TODO: Full page loading screen
      return 'Loading';
    }
    return (
      <Form getApi={this.setFormApi} autoComplete='off'>
        <div className={styles.loginPage}>
          <div className={styles.loginBox} onKeyPress={this.enter}>
            <img className={styles.logoImage} src={`${publicUrl}/logo.png`} />
            <div className={styles.boxHeader}>Log In</div>
            <table>
              <tbody>
                <tr>
                  <td>Username: </td>
                  <td><RequiredText field='username' initialValue={''} /></td>
                </tr>
                <tr>
                  <td>Password: </td>
                  <td><RequiredText field='password' type='password' initialValue={''} /></td>
                </tr>
              </tbody>
            </table>
            <div className={styles.buttonsBox}>
              <PrimaryButton onClick={this.submitLogin}>Log In</PrimaryButton>
              <Link to='/signup'><Button>Sign Up</Button></Link>
            </div>
            <Error>{this.props.loginError}</Error>
          </div>
        </div>
      </Form>

    );
  }
}

const mapStateToProps = state => ({
  loginError: state.account.loginError,
  loginLoading: state.account.status === 'LOADING',
});

const mapDispatchToProps = dispatch => ({
  login: (username, password) => dispatch(login(username, password)),
});

const LoginPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginPageComponent);

export default LoginPage;



// WEBPACK FOOTER //
// ./client/src/components/accountPages/LoginPage.jsx